import { TreeNodeRenderFunction } from '@/components/shared/Tree/types';
import { TreeStore } from '@/stores/local/shared/TreeStore';

import File from './File';
import Folder from './Folder';

export const renderNode: TreeNodeRenderFunction = (store: TreeStore) => {
  if (!store.data) {
    return null;
  }

  if (store.data.type === 'folder') {
    return <Folder key={store.data.id} store={store} model={store.data} />;
  }

  if (store.data.type === 'file') {
    return <File key={store.data.id} store={store} model={store.data} />;
  }

  return null;
};
